import toastr from 'toastr'

// DEMO
// https://codeseven.github.io/toastr/demo.html

toastr.options = {
    positionClass: 'toast-top-right',
    hideDuration: 300,
    closeHtml : '<button><i class="icon-off"></i></button>',
    timeOut: 5000,
    closeButton : true,
    progressBar : true,
} 

export const _Toastr = {
    error (msg){
        toastr.error(`${msg} `);
    },
    success (msg){
        toastr.success(`${msg} `);
    },
    warning (msg){
        toastr.warning(`${msg} `);
    },
    info(msg){
        toastr.info(`${msg} `);
    },
 };
export const msg = {
    error (msg){
        toastr.error(`${msg} `);
    },
    success (msg){
        toastr.success(`${msg} `);
    },
    auto(data){
       if(data.sts == 1){
            toastr.success(data.msg)
       } else{
            toastr.error(data.msg)
       }
    },
    warning (msg){
        toastr.warning(`${msg} `);
    },
    info(msg){
        toastr.info(`${msg} `);
    },
 };